import React, { useEffect, useState } from 'react'
import "./suivis.css"
import { countries } from "../../global/countriesAndSources"
import { deleteKeyword, fetchKeywordsFromUserId } from '../../HTTP/keywords'
import { fetchIgoById, fetchAllRegions } from '../../HTTP/countries'
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import Pagination from '../../Helper/Pagination'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';


const Suivis = () => {
    const user = JSON.parse(localStorage.getItem("user"))
    if (localStorage.getItem("subscriptions") === null) {
      window.location.href = '/'
    } else {
      if (JSON.parse(localStorage.getItem("subscriptions")).data === null) {
        window.location.href = '/'
      }
    }
    const url = new URL(window.location.href)
    if (url.searchParams.get('page') === null) {
        url.searchParams.set('page', 1)
        window.history.pushState({}, '', url)
    }
    const [keywords, setKeywords] = useState({count : 0, rows : []})
    const [keywordsReady, setKeywordsReady] = useState(false)
    const [itemsPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(parseInt(url.searchParams.get('page')))
    const [searchTerm, setSearchTerm] = useState('')

    // États pour les mots-clés sélectionnés
    const [selectedKeywords, setSelectedKeywords] = useState([]);
    const [isCurrentPageAllSelected, setIsCurrentPageAllSelected] = useState(false);
    const [isOneSelected, setIsOneSelected] = useState(false);
    const [launchSearch, setLaunchSearch] = useState(false);
    const [igoNames, setIgoNames] = useState({});

    useEffect(() => {
        setKeywordsReady(false)
        const funKeywords = async () => {
            const resKeywords = await fetchKeywordsFromUserId(user.id, (currentPage - 1) * itemsPerPage, currentPage * itemsPerPage, searchTerm)
            setKeywords(resKeywords)
            
            // Vérifier si tous les mots-clés de la page actuelle sont déjà sélectionnés
            updateCurrentPageSelectionStatus(resKeywords.rows, selectedKeywords);
        }
        funKeywords()
        setKeywordsReady(true)
        setLaunchSearch(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, user.id, itemsPerPage, launchSearch])

    useEffect(() => {
        const igoIds = [...new Set(
            (keywords.rows || [])
                .map((keyword) => keyword.igo_id)
                .filter(Boolean)
        )]

        if (igoIds.length === 0) {
            return
        }

        const missingIgoIds = igoIds.filter((igoId) => !igoNames[igoId])

        if (missingIgoIds.length === 0) {
            return
        }

        const loadIgoNames = async () => {
            try {
                const igoResponses = await Promise.all(
                    missingIgoIds.map(async (igoId) => {
                        const igo = await fetchIgoById(igoId)
                        return [igoId, igo?.label || igo?.name || 'Non']
                    })
                )

                setIgoNames((prevNames) => ({
                    ...prevNames,
                    ...Object.fromEntries(igoResponses)
                }))
            } catch (error) {
                console.error("Erreur lors du chargement des OIG des suivis", error)
            }
        }

        loadIgoNames()
    }, [keywords.rows, igoNames])

    // Vérifier si au moins un mot-clé est sélectionné
    useEffect(() => {
        setIsOneSelected(selectedKeywords.length > 0);
    }, [selectedKeywords]);

    // Mettre à jour le statut de sélection de la page actuelle
    const updateCurrentPageSelectionStatus = (currentPageKeywords, selectedKeywordsList) => {
        if (currentPageKeywords.length === 0) {
            setIsCurrentPageAllSelected(false);
            return;
        }
        
        const allCurrentPageSelected = currentPageKeywords.every(keyword => 
            selectedKeywordsList.some(selected => selected.id === keyword.id)
        );
        
        setIsCurrentPageAllSelected(allCurrentPageSelected);
    };

    const handleKeywordSearch = (e) => {
        e.preventDefault()
        if (url.searchParams.get('query') === null) {
            url.searchParams.set('query', searchTerm)
        } else {
            url.searchParams.set('query', searchTerm)
        }
        window.history.pushState({}, '', url)
        setLaunchSearch(true)
        setCurrentPage(1)
    }

    const handleSearch = async (keyword) => {
      let countryCode = keyword.country ?? keyword.country_code

      // Comme depuis la page igo : une recherche de forum se fait sur le monde (wd)
      if (keyword.igo_id || keyword.region_id || !countryCode) {
        countryCode = 'wd'
      }
      const country = countries.find((c) => c.code === countryCode)

      if (country) {
        sessionStorage.setItem('search_country', JSON.stringify(country))
      }
      sessionStorage.removeItem('search_country_country')
      sessionStorage.removeItem('search_themes_country')

      sessionStorage.setItem('search_query', keyword.keyword)

      const thematicRef = keyword.thematic_id || keyword.thematic
      if (thematicRef && thematicRef !== "") {
        sessionStorage.setItem('thematic', thematicRef)
        if (keyword.thematic) sessionStorage.setItem('thematic_name', keyword.thematic)
      } else {
        sessionStorage.removeItem('thematic')
      }

      let igoQuery = ''
      if (keyword.igo_id) {
        try {
          const igo = await fetchIgoById(keyword.igo_id)
          if (igo?.name) {
            sessionStorage.setItem('search_igo', igo.name)
            igoQuery = `&igo=${encodeURIComponent(igo.name)}`
          } else {
            sessionStorage.removeItem('search_igo')
          }
        } catch (error) {
          sessionStorage.removeItem('search_igo')
        }
      } else {
        sessionStorage.removeItem('search_igo')
      }

      let regionQuery = ''
      if (keyword.region_id) {
        try {
          const response = await fetchAllRegions()
          const regions = Array.isArray(response) ? response : response?.data
          const region = Array.isArray(regions)
            ? regions.find((item) => String(item.id) === String(keyword.region_id))
            : null
          sessionStorage.setItem('search_region', JSON.stringify(region || {
            id: keyword.region_id,
            name: keyword.region_name || 'Région'
          }))
          regionQuery = `&region_id=${encodeURIComponent(keyword.region_id)}`
        } catch (error) {
          console.error("Erreur lors du chargement de la région du mot-clé", error)
          sessionStorage.setItem('search_region', JSON.stringify({
            id: keyword.region_id,
            name: keyword.region_name || 'Région'
          }))
          regionQuery = `&region_id=${encodeURIComponent(keyword.region_id)}`
        }
      } else {
        sessionStorage.removeItem('search_region')
      }

      window.location.href = `/${countryCode}/what-this-country-talk-about?query=${encodeURIComponent(keyword.keyword)}${thematicRef ? `&thematic=${encodeURIComponent(thematicRef)}${keyword.thematic_link ? `&link-id=${keyword.thematic_link}` : ""}` : ''}${igoQuery}${regionQuery}`
    }

    const handleAdd = () => {
        window.location.href = '/addkeywords'
    }

    const handleDelete = async (keywordId) => {
      try {
        await deleteKeyword(keywordId)
        alert('Suppression successfull')
        window.location.reload()
      } catch (error) {
        alert('An error occured while deleting the keyword')
      }
    }

    // Gérer la sélection/désélection d'un mot-clé
    const handleSelectKeyword = (keyword) => {
        setSelectedKeywords(prevSelected => {
            // Vérifier si le mot-clé est déjà sélectionné
            const isSelected = prevSelected.some(item => item.id === keyword.id);
            
            let newSelectedList;
            if (isSelected) {
                // Si déjà sélectionné, on le retire de la liste
                newSelectedList = prevSelected.filter(item => item.id !== keyword.id);
            } else {
                // Sinon, on l'ajoute à la liste
                newSelectedList = [...prevSelected, keyword];
            }
            
            // Mettre à jour le statut de sélection pour la page actuelle
            updateCurrentPageSelectionStatus(keywords.rows, newSelectedList);
            
            return newSelectedList;
        });
    };

    // Gérer la sélection/désélection de tous les mots-clés de la page actuelle
    const handleSelectAllCurrentPage = () => {
        setSelectedKeywords(prevSelected => {
            if (isCurrentPageAllSelected) {
                // Si tous les mots-clés de la page actuelle sont déjà sélectionnés, on les désélectionne
                const newSelectedList = prevSelected.filter(selected => 
                    !keywords.rows.some(keyword => keyword.id === selected.id)
                );
                setIsCurrentPageAllSelected(false);
                return newSelectedList;
            } else {
                // Sinon, on ajoute tous les mots-clés de la page actuelle qui ne sont pas déjà sélectionnés
                const currentPageIds = keywords.rows.map(keyword => keyword.id);
                
                // Filtrer pour ne garder que les mots-clés qui ne sont pas dans la page actuelle
                const selectedFromOtherPages = prevSelected.filter(
                    selected => !currentPageIds.includes(selected.id)
                );
                
                // Ajouter tous les mots-clés de la page actuelle
                const newSelectedList = [...selectedFromOtherPages, ...keywords.rows];
                setIsCurrentPageAllSelected(true);
                return newSelectedList;
            }
        });
    };

    // Fonction pour supprimer en masse
    const handleBulkDelete = () => {
        if (window.confirm(`Êtes-vous sûr de vouloir supprimer ${selectedKeywords.length} mot(s)-clé(s) ?`)) {
            // Supprimer séquentiellement chaque mot-clé
            let deletePromises = selectedKeywords.map(keyword => deleteKeyword(keyword.id));
            
            Promise.all(deletePromises)
                .then(() => {
                    alert("Mots-clés supprimés avec succès !");
                    setSelectedKeywords([]); // Vider la sélection
                    window.location.reload();
                })
                .catch(err => {
                    alert("Une erreur est survenue lors de la suppression de certains mots-clés.");
                });
        }
    };

    return (
      <>
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mt-10 mb:mt-0 mb-4">
          <h1 className="text-2xl font-bold text-center flex-grow">
            Mes mots-clés
          </h1>
        </div>
      {
        keywordsReady && (
          <>
          <form onSubmit={handleKeywordSearch} className="w-full mb-4">
            <div className="flex flex-col space-y-3 lg:flex-row lg:space-y-0 lg:space-x-3">
              {/* Container principal qui prend toute la largeur disponible */}
              <div className="flex-1 flex space-x-2">
                <input
                  type="text"
                  placeholder="Rechercher..."
                  className="flex-1 px-4 py-2.5 rounded-lg border border-gray-200 shadow-sm transition-colors focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 focus:outline-none"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 bg-zemusbis text-white rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                >
                  <SearchIcon />
                </button>
                <button
                  type="button"
                  className="px-4 py-2.5 bg-zemushover text-white rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                  onClick={handleAdd}
                >
                  <AddIcon color='disabled' />
                </button>
              </div>
            </div>
          </form>

          {/* Affichage des actions pour les mots-clés sélectionnés */}
          <div className="mb-4 p-3 bg-blue-100 rounded-lg">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
              <p className="text-blue-800 font-medium">{selectedKeywords.length} mot(s)-clé(s) sélectionné(s)</p>
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={handleBulkDelete}
                  disabled={!isOneSelected}
                  className={`px-3 py-1.5 text-white text-sm rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 ${
                    !isOneSelected ? 'cursor-not-allowed bg-red-300' : 'bg-red-500 hover:bg-red-600'
                  }`}
                >
                  <span className="hidden lg:inline">Supprimer la sélection</span>
                  <span className="lg:hidden">
                    <DeleteIcon fontSize="medium" />
                  </span>
                </button>
              </div>
            </div>
            {!isOneSelected && (
              <p className="mt-2 text-red-600 text-sm">
                Aucun mot-clé sélectionné. Veuillez sélectionner au moins un mot-clé pour effectuer des actions.
              </p>
            )}
          </div>

          <div className={`md:block w-full shadow-md rounded-lg h-[calc(100vh-24rem)] overflow-y-auto`}>
            <table className="w-full table-auto">
              <thead className="bg-gray-100">
                <tr>
                  {/* Colonne pour la sélection */}
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <input 
                      type="checkbox" 
                      checked={isCurrentPageAllSelected && keywords.rows.length > 0}
                      onChange={handleSelectAllCurrentPage}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mot-clé</th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pays</th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Forum global</th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Région</th>
                  <th className="hidden lg:table-cell px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Thématique</th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className='divide-y divide-gray-200'>
                {keywords.rows.map((keyword, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    {/* Cellule avec la case à cocher pour la sélection */}
                    <td className="px-4 py-2">
                      <input 
                        type="checkbox" 
                        checked={selectedKeywords.some(selected => selected.id === keyword.id)}
                        onChange={() => handleSelectKeyword(keyword)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                    </td>
                    <td className="px-4 py-2">{keyword.keyword}</td>
                    <td className="px-4 py-2">{countries.find((c) => c.code === (keyword.country ?? keyword.country_code))?.name}</td>
                    <td className="px-4 py-2">{keyword.igo_id ? (igoNames[keyword.igo_id] || 'Chargement...') : 'Non'}</td>
                    <td className="px-4 py-2">{keyword.region_name || 'Non'}</td>
                    <td className="hidden lg:table-cell px-4 py-2">
                      {keyword.thematic === null || keyword.thematic === "" ? 'Non défini' : keyword.thematic}
                    </td>
                    <td className="px-4 py-2">
                    <button
                        onClick={() => handleSearch(keyword)}
                        className="bg-validbutton hover:bg-validbuttonhover text-white font-bold rounded mr-1 p-1  mb-1 lg:mb-0"
                      >
                        <SearchIcon />
                      </button>
                      <button
                        onClick={() => window.location.href=`/editkeywords/${keyword.id}`}
                        className="bg-zemusbis hover:bg-blue-600 text-white font-bold rounded mr-1 p-1  mb-1 lg:mb-0"
                      >
                        <EditIcon />
                      </button>
                      <button 
                          className="bg-red-500 hover:bg-red-700 text-white font-bold rounded mr-1 p-1  mb-1 lg:mb-0"
                          onClick={() => {
                            if (window.confirm("Are you sure you want to delete this keyword?")) {
                              handleDelete(keyword.id);
                            }
                          }}
                        >
                          <DeleteIcon />
                        </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          </>
        )
      }
    </div>
      <Pagination
        itemsPerPage={itemsPerPage}
        totalItems={keywords.count}
        currentPage={currentPage}
        paginate={setCurrentPage}
      />
    </>
    )


}

export default Suivis
